module.exports = __webpack_public_path__ + "static/media/savetime.e7e86efd.svg";